import React from 'react';
import { Link } from 'react-router-dom';
import Socials from './Socials';

const Footer = () => {
    return (
        <div className='w-full dark-gradient text-200 pb-4'>
            <div className='flex flex-column m-auto w-full p-3 md:w-9 font-sans'>
                {/*<div className='flex gap-3 flex-column md:flex-row justify-content-between w-full line-height-4'>
                    <div className='flex-1'>
                        <strong className='text-lg'>Growspective</strong><br />
                        <Link to={'/'} className='' style={{cursor: 'pointer', textDecoration: 'none', color: 'inherit'}}>Home</Link><br />
                        <Link to={'legal'} className='' style={{cursor: 'pointer', textDecoration: 'none', color: 'inherit'}}>Legal notice</Link>
                    </div>
                    <div className='flex-1'>
                        <strong className='text-lg'>Services</strong><br />
                        <Link to={'/consulting'} className='' style={{cursor: 'pointer', textDecoration: 'none', color: 'inherit'}}>360° consulting</Link><br />
                        <Link to={'/webdev'} className='' style={{cursor: 'pointer', textDecoration: 'none', color: 'inherit'}}>Web and mobile development</Link><br />
                        <Link to={'/tech'} className='' style={{cursor: 'pointer', textDecoration: 'none', color: 'inherit'}}>AI & Blockchain</Link><br />
                        <Link to={'/marketing'} className='' style={{cursor: 'pointer', textDecoration: 'none', color: 'inherit'}}>Marketing</Link>
                    </div>
                </div>*/}
                <div className='w-full text-400 mt-3 mb-2 pt-3' style={{borderTop: '1px solid'}} >
                </div>
                <div className='flex gap-3 flex-column lg:flex-row w-full'>
                    <div className='w-full text-400' >
                        <div className='text-400'>
                            Website by <Link to={'https://growspective.com'} target="_blank" rel="noopener noreferrer"  className='' style={{cursor: 'pointer', textDecoration: 'underline', color: 'inherit'}}>Growspective Consulting</Link><br />
                        </div>
                        <div className='pt-3 text-600'>
                            Copyright © 2024 - Jana Pelikan<br />
                            All rights reserved
                        </div>
                    </div>
                    <div className='justify-content-end flex'>
                        <Socials />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;